import { useEffect, useMemo, useState } from 'react'
import { useLocalStorage } from '@/hooks/useLocaleStorage'

export const RESERVATION_REFUND_ERROR_KEY = 'RESERVATION_ERROR_REFUNDED'
export const RESERVATION_REFUND_ERROR_RESERVATION_ID = 'RESERVATION_REFUND_ERROR_RESERVATION_ID'

export const useModalRefundErrorHandler = () => {
  const { storedValue, setStoredValue, isReady } = useLocalStorage(RESERVATION_REFUND_ERROR_KEY, false, 'boolean')
  const [displayErrorRefundModal, setDisplayErrorRefundModal] = useState(false)

  useEffect(() => {
    if (isReady && storedValue) setDisplayErrorRefundModal(true)
  }, [isReady, storedValue])

  return useMemo(() => {
    return {
      displayErrorRefundModal,
      handleCloseErrorRefundModal: () => {
        setStoredValue(false)
        setDisplayErrorRefundModal(false)
      },
    }
  }, [displayErrorRefundModal, setStoredValue])
}
